export default __webpack_public_path__ + "static/media/sd-dashboard.784a66e0.jpg";